interface AutoOpponentWatchInput {
  matchId: string | null;
  phase: string;
  myTurnOver: boolean;
  opponentSolved: boolean;
  requestedFor: string | null;
  attemptedFor: string | null;
}

/** Otomatik izleme yalnız canlı ve rakibin hâlâ oynadığı turda bir kez açılır. */
export function shouldAutoWatchOpponent(input: AutoOpponentWatchInput): boolean {
  return Boolean(
    input.matchId &&
      input.phase === "live" &&
      input.myTurnOver &&
      !input.opponentSolved &&
      input.requestedFor !== input.matchId &&
      input.attemptedFor !== input.matchId,
  );
}
